import { Injectable } from '@angular/core';

import { AuthService } from '../../../core';
import { Regiao } from '../regiao';
import { RegiaoSearch } from '../regiao-search';
import { RegiaoIntegracaoERP } from '../regiao-integracao';

/** Service que valida o acessos a funcionalidades referentes as regiões */
@Injectable({
    providedIn: 'root'
})
export class RegiaoAuthGuardService {

    constructor(private authService: AuthService) { }

    /** Verifica se pode editar uma região */
    canEdit(): boolean {
        return this.authService.isAdministrador();
    }

    /** Verifica se pode importar as regiões do ERP */
    canImportErp(): boolean {
        return this.authService.podeImportarErp();
    }

    /** Verifica se pode importar o região do ERP */
    canImportOneErp(entity: RegiaoIntegracaoERP): boolean {
        if (!entity) {
            return false;
        }
        // Somente se estiver integrado com o ERP
        if (!entity.idIntegracaoErp) {
            return false;
        }

        return this.authService.podeImportarErp();
    }
}
